import React, { memo, useState, useEffect } from 'react'
import { Button, HeadingText, BodyText, Avatar } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { PP_LOGGED_OUT_URL } from '../../../../constants/constants'
import { fptiCustomImpression } from '../../../../utils'
import DATAPRIVACY_FPTI from '../../../../config/data-privacy-fpti'
const loggedOutFPTI = DATAPRIVACY_FPTI.LOGGED_OUT

const VerificationSuccess = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(loggedOutFPTI.THANKS_PAGE_IMPRESSION)
    }
  }, [])

  const handleLinkClick = (event) => {
    event.preventDefault()
    location.href = PP_LOGGED_OUT_URL
  }
  return (
    <>
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen text-center">
            <div className="flex-center">
              <Avatar
                src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-success.svg"
                className="focusedimg"
                alt="success"
              />
            </div>
            <HeadingText size="sm" className="">
              <Message id="dsrLoggedout.thankspage.header" />
            </HeadingText>

            <BodyText className="requestForm-section-desc">
              <Message id="dsrLoggedout.thankspage.content" />
            </BodyText>

            <BodyText className="requestForm-section-desc">
              <span>
                <Message id="dsrLoggedout.thankspage.requestid" />
              </span>
              <strong className="s-value"> {props.reqid}</strong>
            </BodyText>

            <BodyText>
              <Button
                theme="v2"
                tertiary
                onClick={handleLinkClick}
                className=""
              >
                <Message id="dsrLoggedout.thankspage.createanewrequest" />
                <span className="tertiary-button--icon" />
              </Button>
            </BodyText>
          </section>
        </div>
      </section>
    </>
  )
})
VerificationSuccess.displayName = 'VerificationSuccess'

export default VerificationSuccess
